module.exports = __webpack_public_path__ + "static/wrkat-env1-min-a09d8a0db70bca406a029fb2663cf00c.jpg";